import "./index.css";
import "./scripts/scroll_restoration";
import "./scripts/cleanUrl";
import "./scripts/tab_navigation";
import "./scripts/localstorage_seperator";
import "./scripts/url_param_handler";
import "./scripts/href_sort_interceptor";
import "./scripts/alpine_init_stores";
import "./scripts/injection-protector";
import "./scripts/broken_image_handler";
import "./scripts/theme_color";
import "./scripts/alpine_components";
import "./scripts/translation-service";
import "./scripts/auto-translate";
import "./scripts/help_tooltip";
import "./scripts/cookies_notice";
import "./scripts/select_menu";
import "./scripts/newsletter_popup";
import "./scripts/modal";
import "./scripts/shared_htmx_modal";
import "./scripts/cookie_consent";
import "./scripts/footer_newsletter";
import "./scripts/quick_view";
import "./scripts/sort_control";
import "./scripts/toastify";
import "./scripts/subscription_popup";
import "./scripts/subscription_slider";
import "./scripts/search_dropdown";
import "./scripts/google_translate_switcher";

// TODO: widget CSS files are compiled as standalone files AND pulled into styles.min.css here — deduplicate.
// Need to exclude widget CSS from this glob once standalone loading is verified on all widgets.
import.meta.glob("./*/**/*.css", { eager: true });

window.buildWantModal = function (el) {
    return {
        title: el.dataset.modalTitle || '',
        htmx_url: '',
        htmx_method: 'post',
        htmx_vals: {
            workflows: ['add_to_want_ui'],
            jinja_data: {
                want_type: el.dataset.wantType,
                item_id: el.dataset.itemId,
                item_title: el.dataset.itemTitle,
                language_code: el.dataset.lang || 'en',
            },
        },
        max_width: 'sm:max-w-lg',
        show_close_button: true,
    };
};
const scripts = import.meta.glob(
  [
    "./**/*.js",
    "!./main.js",
    // core scripts — explicitly imported above
    "!./scripts/scroll_restoration.js",
    "!./scripts/cleanUrl.js",
    "!./scripts/tab_navigation.js",
    "!./scripts/localstorage_seperator.js",
    "!./scripts/url_param_handler.js",
    "!./scripts/href_sort_interceptor.js",
    "!./scripts/alpine_init_stores.js",
    "!./scripts/injection-protector.js",
    "!./scripts/broken_image_handler.js",
    "!./scripts/theme_color.js",
    "!./scripts/alpine_components.js",
    "!./scripts/translation-service.js",
    "!./scripts/auto-translate.js",
    // component scripts — now built as individual standalone files
    "!./scripts/cookie_consent.js",
    "!./scripts/shared_htmx_modal.js",
    "!./scripts/quick_view.js",
    "!./scripts/modal.js",
    "!./scripts/sort_control.js",
    "!./scripts/toastify.js",
    "!./scripts/newsletter_popup.js",
    "!./scripts/footer_newsletter.js",
    "!./scripts/subscription_popup.js",
    "!./scripts/subscription_popup.js",
    "!./scripts/subscription_slider.js",
    "!./scripts/footer_newsletter.js",
    "!./scripts/cookies_notice.js",
    "!./scripts/search_dropdown.js",
    "!./scripts/select_menu.js",
    "!./scripts/help_tooltip.js",
    "!./scripts/google_translate_switcher.js",
    "!**/*.test.js",
    "!**/*.spec.js",
  ],
  { eager: true },
);

